import deCH from './de_CH'
import frCH from './fr_CH'
import itCH from './it_CH'

export default {
  de_CH: deCH,
  fr_CH: frCH,
  it_CH: itCH
}
